// let lastScrollTop = 0;
// let header = document.querySelector(".shopify-section--header");
// let mobileDock = document.querySelector(".mobile-dock");

// let icons = document.querySelectorAll(".nav-icon");
// let currentPage = window.location.href;
// let cartIcon = document.querySelector("a.cart");
// let profileButton = document.querySelector("a.profile");

// icons?.forEach((icon) => {
//   let redirectURL = icon.parentElement.href;
//   let iconData = icon.dataset.icon;

//   if (currentPage === redirectURL && iconData) {
//     let ele = icon.querySelector("svg")
//       ? icon.querySelector("svg")
//       : icon.querySelector("img");

//     if (ele) {
//       let newEle;

//       if (iconData.startsWith("<svg")) {
//         let svg = new DOMParser()
//           .parseFromString(iconData, "text/html")
//           .querySelector("svg");
//         if (svg) newEle = svg;
//       } else {
//         newEle = document.createElement("img");
//         newEle.src = iconData;
//       }

//       icon.replaceChild(newEle, ele);
//     }
//   }
// });

// // Show cart drawer when cart menu icon gets clicked
// cartIcon?.addEventListener("click", () => {
//   document.querySelector('.header__icon-wrapper[aria-label="Cart"]')?.click();
// });
// // show Kwik pass login option
// profileButton?.addEventListener("click", (event) => {
//   let customerStatus = profileButton.getAttribute("data-customer");

//   if (customerStatus === "") {
//     customerStatus = "disable";
//   }

//   if (customerStatus === "disable") {
//     event.preventDefault();
//     let loginButton = document.querySelector("#kp-login-button-header-logo");
//     loginButton?.click();
//     const getCookie = (name) => {
//       const value = `; ${document.cookie}`;
//       const parts = value.split(`; ${name}=`);
//       if (parts.length === 2) return parts.pop().split(";").shift();
//     };

//     let loginCookies = getCookie("_shopify_y");
//     console.log(loginCookies);
//     if (loginCookies) {
//       const url = `https://brand-loyalty.popclub.co.in/api/get-available-coins?shop=two-brothers-organic-farms-amorearth.myshopify.com&key=${loginCookies}`;
//       fetch(url)
//         .then((response) => {
//           if (!response.ok) {
//             throw new Error(`HTTP error! Status: ${response.status}`);
//           }
//           return response.json();
//         })
//         .then((data) => {
//           if (data.success == true) {
//             profileButton.setAttribute("data-customer", "active");
//           }
//         })
//         .catch((error) => {
//           console.error("Network or Fetch Error:", error);
//         });
//     }
//   } else if (customerStatus === "active") {
//     let accountPageUrl = "/account";
//     window.location.href = accountPageUrl;
//   }
// });





let lastScrollTop = 0; 
let header = document.querySelector(".shopify-section--header");
let mobileDock = document.querySelector(".mobile-dock");

let icons = document.querySelectorAll(".nav-icon");
let currentPage = window.location.href;
let cartIcon = document.querySelector('a.cart');
let profileButton = document.querySelector("a.profile")
 


icons?.forEach((icon) => {
  let redirectURL = icon.parentElement.href;
  let iconData = icon.dataset.icon;

  if (currentPage === redirectURL && iconData) {
    let ele = icon.querySelector("svg")
      ? icon.querySelector("svg")
      : icon.querySelector("img");

    if (ele) {
      let newEle;

      if (iconData.startsWith("<svg")) {
        let svg = new DOMParser()
          .parseFromString(iconData, "text/html")
          .querySelector("svg");
        if (svg) newEle = svg;
      } else {
        newEle = document.createElement("img");
        newEle.src = iconData;
      }

      icon.replaceChild(newEle, ele);
    }
  }
});

// Show cart drawer when cart menu icon gets clicked
cartIcon?.addEventListener("click", () => {
  document.querySelector('.header__icon-wrapper[aria-label="Cart"]')?.click();
});
// show Kwik pass login option 
profileButton?.addEventListener("click", (event) => {
  let customerStatus = profileButton.getAttribute("data-customer");
  
  if (customerStatus === "") {
    customerStatus = "disable";
  }
  
  if (customerStatus === "disable") {
    event.preventDefault();
    let loginButton = document.querySelector("#kp-login-button-header-logo");
    loginButton?.click();
    profileButton.setAttribute("data-customer", "active");
  } else if (customerStatus === "active") {
    let accountPageUrl = "/account";
    window.location.href = accountPageUrl;
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const sliders = document.querySelectorAll(".slider__grid"); // Select all slider containers

  sliders.forEach((slider) => {
    const slides = slider.querySelectorAll(".slider_custom_item");
    const totalSlides = slides.length;

    if (totalSlides === 0) return; // Skip if there are no slides

    // Clone the first slide and append it to the end
    const firstSlideClone = slides[0].cloneNode(true);
    slider.appendChild(firstSlideClone);

    let currentIndex = 0;

    setInterval(() => {
      currentIndex++;
      slider.style.transform = `translateY(-${currentIndex * 30}px)`; 

      if (currentIndex === totalSlides) {
        setTimeout(() => {
          slider.style.transition = "none"; 
          slider.style.transform = "translateY(0)";
          currentIndex = 0;
          setTimeout(() => slider.style.transition = "transform 0.5s ease-in-out", 10); 
        }, 800); // Wait for the transition to complete
      }
    }, 3000);
  });
});
